
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import BrandManifesto from './components/BrandManifesto';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';

const HomePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "宫廷养森",
    "description": "宫廷养森品牌传承故宫千年古方智慧，融合北京秘方传承中医医院现代中医验证，为您呈现内调外养的完整美丽解决方案",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
    "logo": "https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/a9def463ca32930876b6ebe479fd9734.png",
    "sameAs": [
      "https://weibo.com/gongtingyangsen",
      "https://www.xiaohongshu.com/gongtingyangsen"
    ],
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "CN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service"
    }
  };

  return (
    <>
      <SEOHead
        title="宫廷养森官网 - 传承千年宫廷古方，内调外养美丽方案"
        description="宫廷养森品牌传承故宫千年古方智慧，融合北京秘方传承中医医院现代中医验证，为您呈现内调外养的完整美丽解决方案。源自紫禁城，验自御医堂，养于内美于外。"
        keywords="宫廷养森,故宫古方,中医养生,内调外养,美容护肤,传统中医，北京秘方传承中医医院"
        path="/"
        schemaData={schemaData}
      />
      <div className={`min-h-screen bg-stone-50 transition-opacity duration-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
        <Navigation />
        <main>
          <Hero />
          <BrandManifesto />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
